import { AUTO_ABSENT_DEFAULT, usesCheckIn } from "@teamna/shared";
import { FormSection, InlineError, ToggleRow, showToast } from "../components/index.ts";
import { useLabels } from "@teamna/web-client/hooks/use-labels.ts";
import { useOwnerBusiness } from "@teamna/web-client/hooks/use-owner.ts";
import { useUpdateBusiness } from "@teamna/web-client/hooks/use-setup.ts";

/**
 * Check-in by name (I1), on the Business tab where clients pick each class: the job that marks
 * absent the clients who did not come, 10 minutes after the start. On by default. Off: the
 * instructor marks the rest.
 */
export function CheckInSection({ businessId }: { businessId: string }) {
  const { label } = useLabels();
  const business = useOwnerBusiness(businessId);
  const update = useUpdateBusiness(businessId);
  if (!business.data || !usesCheckIn(business.data.classFill)) return null;
  const on = business.data.settings.autoAbsent ?? AUTO_ABSENT_DEFAULT;
  const staff = label("staff");
  return (
    <FormSection
      title="Check-in"
      description={`The class list opens 15 minutes before the class. The ${staff} taps each ${label("participant")} who comes.`}
    >
      <ToggleRow
        label="Mark absent who did not come"
        hint={
          on
            ? `On: 10 minutes after the start, Teamna marks absent each booked ${label("participant")} who did not check in. The ${staff} can change a mark after that.`
            : `Off: the ${staff} marks absent who did not come.`
        }
        checked={on}
        disabled={update.isPending}
        onChange={(next) =>
          update.mutate(
            { settings: { autoAbsent: next } },
            { onSuccess: () => showToast(next ? "Teamna marks absent who did not come." : "Teamna does not mark absent from now on.") },
          )
        }
      />
      {update.error ? <InlineError error={update.error} /> : null}
    </FormSection>
  );
}
